import React, { useEffect } from "react";

import {
  IgCheckbox,
  IgListItemButton,
  IgSelect,
  IgTypography,
} from "@intelligems/ig-theme";
import { ChannelType, TrafficConfigFilterType } from "@intelligems/ig-types";
import { MenuItem } from "@mui/material";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import { channelTypeList } from "@src/components/AudienceFilters/utils";
import { getChannelTypeListCount } from "@src/features/analytics/analyticsFilters/utils";

interface ChannelProps {
  onClick: (arg1: any, arg2?: any) => void;
  channels: ChannelType[] | null;
  location?: "analytics" | "audience";
  isView?: boolean;
}

export const Channel = ({
  channels,
  onClick,
  location = "analytics",
  isView,
}: ChannelProps) => {
  const selectedCards = (selectedVisitorType: ChannelType | null): boolean => {
    if (!selectedVisitorType) return (channels || []).length === 0;
    return (channels || []).includes(selectedVisitorType);
  };

  return (
    <Grid container spacing={2} direction={"row"}>
      {channelTypeList.map((channelType) => (
        <Grid key={channelType.key} size={location === "analytics" ? 4 : 2}>
          <IgListItemButton
            buttonFontWeight={400}
            disabled={isView}
            label={channelType.label}
            onClick={() => {
              onClick(channelType.key || null, "channelType");
            }}
            selected={selectedCards(channelType.key)}
          />
        </Grid>
      ))}
    </Grid>
  );
};

interface ChannelSelectProps {
  onChange: (value: any, changeKey: "key" | "filter" | "value") => void;
  channelType: ChannelType;
}

export const ChannelSelect = ({
  channelType,
  onChange,
}: ChannelSelectProps) => {
  // handle when type switched and value not compatible
  useEffect(() => {
    if (!channelTypeList.find((channel) => channel.key === channelType))
      onChange(channelTypeList[1].key, "value");
  }, []);

  return (
    <Grid>
      <IgSelect
        variant={"outlined"}
        key={`channel-type`}
        value={channelType || channelTypeList[1].key}
        onChange={(e) => {
          onChange(e.target.value as TrafficConfigFilterType, "value");
        }}
      >
        {channelTypeList
          .filter((channel) => !!channel.key && channel.key !== "Other")
          .map((channel) => (
            <MenuItem key={`${channel.key}`} value={channel.key!}>
              <Grid container direction={"column"}>
                <Grid>
                  <IgTypography>{channel.label}</IgTypography>
                </Grid>
              </Grid>
            </MenuItem>
          ))}
      </IgSelect>
    </Grid>
  );
};

interface ChannelChecklistProps {
  onClick: (arg1: any, arg2?: any) => void;
  channels: string[] | null;
  isView?: boolean;
}

export const ChannelChecklist = ({
  channels,
  onClick,
  isView,
}: ChannelChecklistProps) => {
  const selectedBox = (selectedVisitorType: string | null): boolean => {
    if (!selectedVisitorType)
      return (channels || []).length === getChannelTypeListCount(true);
    return (channels || []).includes(selectedVisitorType);
  };

  return (
    <Stack>
      {[...channelTypeList, { key: "Other", label: "Other" }].map(
        (channelType) => (
          <Grid
            container
            key={channelType.key}
            alignItems={"center"}
            onClick={() => {
              onClick(channelType.key || null, "channelType");
            }}
            sx={{ "& :hover": { cursor: "pointer" } }}
          >
            <IgCheckbox
              disabled={isView}
              checked={selectedBox(channelType.key)}
            />
            <IgTypography>{channelType.label}</IgTypography>
          </Grid>
        )
      )}
    </Stack>
  );
};
